// extracted by mini-css-extract-plugin
module.exports = {"center":"basic_center__2k0ML","blur":"basic_blur__1Qem-"};